export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  ERROR = 'error',
  LOADED = 'loaded',
}

export enum KeyCodesEnum {
  ENTER = 'Enter',
  NUMPAD_ENTER = 'NumpadEnter',
  SPACE = 'Space',
  TAB = 'Tab',
  LEFT_ARROW = 'ArrowLeft',
  RIGHT_ARROW = 'ArrowRight',
  UP_ARROW = 'ArrowUp',
  DOWN_ARROW = 'ArrowDown',
  DELETE = 'Delete',
  BACKSPACE = 'Backspace',
  ESCAPE = 'Escape',
  SHIFT = 'ShiftLeft',
}
